import ComposeTimeAdapter from 'owa-addins-apis/lib/adapters/ComposeTimeAdapter';
import RecurrenceAdapter from 'owa-addins-apis/lib/adapters/ComposeRecurrenceAdapter';
import { ApiMethodCallback } from '../ApiMethod';
import { convertRecurrenceToAddinFormat } from 'owa-addins-recurrence';
import { createSuccessResult } from '../ApiMethodResponseCreator';
import { getAdapter } from '../../adapters/AdapterManager';

export default async function getRecurrenceAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: any,
    callback: ApiMethodCallback
) {
    const adapter = getAdapter(hostItemIndex) as RecurrenceAdapter & ComposeTimeAdapter;
    const recurrenceType = await adapter.getRecurrence();
    const recurrence = convertRecurrenceToAddinFormat({
        recurrenceType,
        timeZone: adapter.getTimeZone(),
        endTime: adapter.getEndTime(),
        startTime: adapter.getStartTime(),
    });
    callback(createSuccessResult(recurrence));
}
